import i18n from '@/app/i18n'

/**
 * Lets an extension ship its own UI strings under its own namespace, e.g.
 * addTranslations('retail', { et: {...}, en: {...} }) then useTranslation('retail').
 */
export function addTranslations(namespace: string, resources: Record<string, Record<string, string>>): void {
    for (const [language, strings] of Object.entries(resources)) {
        i18n.addResourceBundle(language, namespace, strings, true, true)
    }
}
